<template>
  <v-row>
    <v-col class="mt-2" cols="12" lg="7" offset-lg="1">
      <!-- breadcrumbs  -->
      <v-breadcrumbs :items="breadcrumbs" divider=">" class="pl-1 pb-3" />

      <v-tabs
        v-model="tabModel"
        background-color="#551738"
        height="60px"
        light
        py-2
      >
        <v-tabs-slider color="white"></v-tabs-slider>
        <v-tab :to="{ name: 'AddPension' }" :ripple="false" class="white--text">
          <v-icon class="white--text mr-2" small>money</v-icon>Pension
        </v-tab>
        <v-tab href="#insurance" :ripple="false" class="white--text">
          <v-icon class="white--text mr-2" small>medical_services</v-icon
          >Insurance
        </v-tab>
        <v-tab
          :to="{ name: 'AddCustomBenefit' }"
          :ripple="false"
          class="white--text"
        >
          <v-icon class="white--text mr-2" small>shuffle</v-icon>Custom
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tabModel">
        <v-tab-item :value="'insurance'">
          <v-card>
            <v-card-text>
              <v-form ref="form" valid="valid">
                <v-row>
                  <v-col cols="12" lg="7">
                    <v-text-field
                        label="Title *"
                        validate-on-blur
                        :rules="[validationRules.required]"
                        clearable
                        v-model="benefit.title"
                    />
                    <v-text-field
                        label="Subheading *"
                        validate-on-blur
                        :rules="[validationRules.required]"
                        clearable
                        v-model="benefit.name"
                    />
                    <v-text-field
                        :rules="[validationRules.required]"
                        label="Provider name"
                        validate-on-blur
                        clearable
                        hint="Name of the company that offers this benefit"
                        v-model="benefit.provider_name"
                    />
                    <v-select
                        label="Location*"
                        :rules="[validationRules.required]"
                        validate-on-blur
                        clearable
                        :items="countries"
                        item-text="name"
                        item-value="name"
                        v-model="benefit.location"
                    />
                    <v-textarea
                        label="Benefit details*"
                        :rules="[validationRules.required]"
                        validate-on-blur
                        clearable
                        v-model="benefit.information"
                    />
                    <v-file-input
                        v-model="fileInput"
                        show-size
                        label="Upload an image or logo"
                        accept="image/*"
                    ></v-file-input>

                    <v-select
                        label="Status*"
                        :rules="[validationRules.required]"
                        validate-on-blur
                        clearable
                        persistent-hint
                        hint="Only active benefits will be visible to employees"
                        :items="statuses"
                        item-text="name"
                        item-value="name"
                        v-model="benefit.status"
                    />
                  <!--  <v-text-field
                        label="Cost *"
                        :rules="[validationRules.required]"
                        validate-on-blur
                        clearable
                        hint="Annual cost of this benefit"
                        v-model="benefit.cost"
                        class="mt-4"
                    />
                    <v-text-field
                        label="Currency *"
                        :rules="[validationRules.required]"
                        validate-on-blur
                        clearable
                        v-model="benefit.currency"
                    /> -->
                  </v-col>
                  <v-col cols="12" lg="5" />
                </v-row>
                <v-btn depressed class="save rounded-sm white--text ml-0 mt-3" @click="save">Save</v-btn>
              </v-form>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-col>

    <v-col class="px-1 pa-3" cols="12" lg="3">
      <v-card class="mt-15 mb-3">
        <v-card-text>
          <div class="subheading font-weight-medium text-capitalize">
            Save on insurance now !!
          </div>
          <div class="grey--text text--darken-1 mt-2 font-weight-medium">
            Thanks to all you members of LessAdmin, we’ve managed to negotiate a
            special deal on insurance exclusively for members of the community.
          </div>
          <div class="grey--text mt-2">
            When clicking the button below, our insurance partner XX will get in
            touch
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn class="rounded-sm white--text action ml-2" depressed
            >Yes. Give me an offer</v-btn
          >
        </v-card-actions>
        <v-card-text>
          <div class="subheading mt-2">Why does insurance matter?</div>
          <div class="grey--text text--darken-1 mt-1">
            If you have employees you need to offer a Insurance plan. This can
            be a great benefit. We've done it easy to understand.
          </div>
        </v-card-text>
      </v-card>

      <v-card class="mt-2 mb-3">
        <v-card-text>
          <div class="subheading font-weight-medium text-capitalize">
            Become a benefit provider !
          </div>
          <div class="grey--text text--darken-1 mt-2">
            Contribute to the community by offering your products and services to other users and companies.
            We only ask that you give back in the form of a unique offer or discount.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn class="rounded-sm white--text action ml-2" depressed
                 @click="manageOfferings"
          >Manage your offers
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card class="mt-2">
        <v-card-text>
          <div class="subheading font-weight-medium">
            Insurance plan preview
          </div>
          <div class="grey--text mt-1">
            Add details in the form to for live preview
          </div>
        </v-card-text>
        <v-img max-height="240" v-if="benefit.url" :src="benefit.url"/>
        <v-card-text primary-title>
          <div v-if="benefit">
            <h2>{{ benefit.name }}</h2>
            <div class="subheading mb-2">{{ benefit.title }}</div>
           <!--  <div class="body-2  mb-1">
              Cost : {{ benefit.cost }} {{ benefit.currency }} / {{ benefit.unit }}
            </div> -->
            <div class="body-2  mb-1">
              Provider : {{ benefit.provider_name }}
            </div>
            <div class="body-2  mb-1">
              Category : {{ benefit.category }}
            </div>
            <div class="body-2  mb-1">
              Location :
              {{ benefit.sub_location ? benefit.sub_location + ', ' : '' }}
              {{ benefit.location ? benefit.location : '' }}
            </div>
          </div>
          <div>
            <div class="subheading grey--text mt-4 text--darken-1">
              {{ benefit.information }}
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-col>

    <v-snackbar v-model="snackbar" :bottom="true" :right="true">
      {{ snackbarMessage }}
      <v-btn color="pink" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-row>
</template>
<script>
import {mapGetters}  from 'vuex';

import {Actions}     from '@/views/actions';
import {Breadcrumbs} from '@/views/breadcrumbs';
import {Component}   from '@/views/component';
import {Constants}   from '@/views/constants';

export default {
  name: Component.Protected.Benefit.Insurance.Add,
  data: () => ({
    tabModel: 'insurance',
    endDateModal: false,
    startDateModal: false,
    breadcrumbs: Breadcrumbs.Benefit.Insurance.Add,
    benefit: {},
    statuses: Constants.Benefits.Status.Obj,
    valid: false,
    fileInput: [],
  }),
  computed: {
    ...mapGetters(["countries", "userInfo", "companyInfo"]),
  },
  methods: {
    manageOfferings() {
      this.$router.push({name: Component.Protected.Benefit.Provider.Info});
    },
    init() {
      this.benefit = {
        //cost: '',
        //unit: Constants.Benefits.Unit.Person,
        location: this.companyInfo.location,
        sub_location: '',
        information: '',
        name: '',
        provider_id: null,
        provider_name: '',
        status: Constants.Benefits.Status.Active,
        title: 'Insurance Plan',
        type: Constants.Benefits.Type.B2C,
        url: '',
        category: Constants.Benefits.Category.Insurance,
        //currency: '',
      };
    },
    setup() {
      if (this.userInfo.role !== Constants.Roles.HR) {
        this.$router.push({ name: Component.Protected.Benefit.List });
        return false;
      }
      this.init();
    },
    save() {
      if (this.$refs.form.validate()) {
        //Logo is uplaoded
        if (this.fileInput != ""){
        const fileName = `company/${this.userInfo.namespace}/benefit/${this.fileInput.name.replaceAll(" ", "_")}`
        const data = {
          action: 'addBenefit',
          fileName: fileName,
          metadata: {
            customMetadata: {
              namespace: this.userInfo.namespace,
              uid: this.userInfo.uid,
              type: "image",
            },
          },
          payload: {...this.benefit, cost: parseFloat(this.benefit.cost), url: ""},
          content: this.fileInput,
        };

        this.$store
          .dispatch(Actions.Firebase.UploadImage, data)
          .then(() => {
            this.$router.push({name: Component.Protected.Benefit.List});
          })
          .catch((err) => {
            console.error(Constants.Benefits.Messages.Error.Add, err);
            this.snackbar = true;
            this.snackbarMessage = Constants.Benefits.Messages.Error.Add;
          })
          .finally(() => {
            this.fileInput = null;
          });
          return;
        }
        //Logo is not uploaded
        let data = {...this.benefit, cost: parseFloat(this.benefit.cost)};
        this.$store.dispatch(Actions.Benefits.Add, data).then(() => {
          this.$router.push({name: Component.Protected.Benefit.List});
        }).catch((err) => {
          console.error(Constants.Benefits.Messages.Error.Add, err);
          this.snackbar = true;
          this.snackbarMessage = Constants.Benefits.Messages.Error.Add;
        });
      }
    },
  },
  created() {
    if (this.userInfo && this.companyInfo && this.countries) {
      this.setup();
    } else {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.setup());
    }
  },
};
</script>
<style scoped>
* >>> div.v-tabs__container {
  height: 60px !important;
  padding-left: 10px;
}
* >>> div.v-picker__title {
  background-color: #551738 !important;
  border-color: #551738 !important;
}
* >>> div.v-date-picker-table {
  height: 200px !important;
}
* >>> div.v-item-group {
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}
</style>